export default "__VITE_ASSET__jN6AGkzs__"